import React, { forwardRef } from "react";
import SpellChecked from "./SpellChecked";

/** Drop-in replacement for antd `Input.TextArea` with spell check. */
export const SpellCheckTextArea = forwardRef((props, ref) => (
  <SpellChecked as="textarea" ref={ref} {...props} />
));
SpellCheckTextArea.displayName = "SpellCheckTextArea";

/** Drop-in replacement for antd `Input` with spell check. */
export const SpellCheckInput = forwardRef((props, ref) => (
  <SpellChecked as="input" ref={ref} {...props} />
));
SpellCheckInput.displayName = "SpellCheckInput";
